var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_9360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5.50391C3 6.03434 3.21071 6.54305 3.58579 6.91812C3.96086 7.29319 4.46957 7.50391 5 7.50391C5.53043 7.50391 6.03914 7.29319 6.41421 6.91812C6.78929 6.54305 7 6.03434 7 5.50391C7 4.97347 6.78929 4.46477 6.41421 4.08969C6.03914 3.71462 5.53043 3.50391 5 3.50391C4.46957 3.50391 3.96086 3.71462 3.58579 4.08969C3.21071 4.46477 3 4.97347 3 5.50391Z",
    stroke: "#1D4B3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5039C17 20.0343 17.2107 20.543 17.5858 20.9181C17.9609 21.2932 18.4696 21.5039 19 21.5039C19.5304 21.5039 20.0391 21.2932 20.4142 20.9181C20.7893 20.543 21 20.0343 21 19.5039C21 18.9735 20.7893 18.4648 20.4142 18.0897C20.0391 17.7146 19.5304 17.5039 19 17.5039C18.4696 17.5039 17.9609 17.7146 17.5858 18.0897C17.2107 18.4648 17 18.9735 17 19.5039Z",
    stroke: "#1D4B3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5.50391C17 6.03434 17.2107 6.54305 17.5858 6.91812C17.9609 7.29319 18.4696 7.50391 19 7.50391C19.5304 7.50391 20.0391 7.29319 20.4142 6.91812C20.7893 6.54305 21 6.03434 21 5.50391C21 4.97347 20.7893 4.46477 20.4142 4.08969C20.0391 3.71462 19.5304 3.50391 19 3.50391C18.4696 3.50391 17.9609 3.71462 17.5858 4.08969C17.2107 4.46477 17 4.97347 17 5.50391Z",
    stroke: "#1D4B3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5039C3 20.0343 3.21071 20.543 3.58579 20.9181C3.96086 21.2932 4.46957 21.5039 5 21.5039C5.53043 21.5039 6.03914 21.2932 6.41421 20.9181C6.78929 20.543 7 20.0343 7 19.5039C7 18.9735 6.78929 18.4648 6.41421 18.0897C6.03914 17.7146 5.53043 17.5039 5 17.5039C4.46957 17.5039 3.96086 17.7146 3.58579 18.0897C3.21071 18.4648 3 18.9735 3 19.5039Z",
    stroke: "#1D4B3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.50391H17M5 7.50391V17.5039M19 7.50391V17.5039",
    stroke: "#1D4B3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_9360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.503906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogNodes);
export default __webpack_public_path__ + "static/media/catalogNodes.3535a023.svg";
export { ForwardRef as ReactComponent };